const LIST_ITEM = /^\s*([-*+]|\d+[.)])\s/;
const FENCE = /^\s*```/;

export function lintPrompt(text) {
  const notes = [];
  const lines = String(text || '').split('\n');
  const starts = [];
  let offset = 0;
  lines.forEach((line) => {
    starts.push(offset);
    offset += line.length + 1;
  });
  const note = (i, message) => notes.push({ line: i + 1, offset: starts[i], length: lines[i].length, message });

  let inFence = false;
  let fenceLine = -1;
  lines.forEach((line, i) => {
    const trimmed = line.trim();
    const prev = i > 0 ? lines[i - 1] : '';
    if (FENCE.test(line)) {
      inFence = !inFence;
      fenceLine = inFence ? i : -1;
      return;
    }
    if (inFence) return;

    if (/^=+$/.test(trimmed) && trimmed.length >= 3 && prev.trim()) {
      note(i, 'A row of = under text turns the line above into a heading.');
    } else if (/^-+$/.test(trimmed) && trimmed.length >= 3 && prev.trim() && !LIST_ITEM.test(prev)) {
      note(i, 'A row of - under text turns the line above into a heading.');
    } else if (/={4,}/.test(trimmed) && /[^=\s]/.test(trimmed)) {
      const label = trimmed.replace(/=+/g, '').trim();
      note(i, `A ==== banner. A markdown heading reads better: ## ${label}`);
    }

    if (/^( {4}|\t)/.test(line) && trimmed && !prev.trim() && !LIST_ITEM.test(line)) {
      note(i, 'Indented four spaces after a blank line, so it shows as a code block.');
    }

    const ticks = (line.match(/`/g) || []).length;
    if (ticks % 2 === 1) note(i, 'Unmatched backtick: the rest of the line shows as code.');

    const bold = (line.match(/\*\*/g) || []).length;
    if (bold % 2 === 1) note(i, 'Unmatched **: bold runs on past where you meant.');
  });
  if (inFence) note(fenceLine, 'This ``` code block is never closed.');

  const source = String(text || '');
  const lineAt = (index) => starts.filter((s) => s <= index).length - 1;
  const opened = [];
  const edges = /\{param_(start|end):(\w+)\}/g;
  let m = edges.exec(source);
  while (m) {
    const [, edge, name] = m;
    if (edge === 'start') {
      opened.push({ name, index: m.index });
    } else {
      const at = opened.map((o) => o.name).lastIndexOf(name);
      if (at === -1) note(lineAt(m.index), `{param_end:${name}} has no {param_start:${name}} before it, so the marker text reaches the model.`);
      else opened.splice(at, 1);
    }
    m = edges.exec(source);
  }
  opened.forEach((o) => note(lineAt(o.index), `{param_start:${o.name}} is never closed with {param_end:${o.name}}, so the clause is never dropped and the marker text reaches the model.`));

  return notes.sort((a, b) => a.line - b.line);
}
